import axios from 'axios';

import { currentBrand, integrationApiBaseUrl } from '../config';

export const CpDataApi = axios.create({
    baseURL: integrationApiBaseUrl,
    paramsSerializer: {
        encode: (param) => encodeURIComponent(param),
    },
});

export const CpContentApi = axios.create({
    baseURL: '/contents',
    headers: {
        'X-CP-Brand': currentBrand,
    },
});
